import React from 'react'
import { Form, Input } from 'antd';


export default function InputHidden(props) {
    return (
        <Form.Item
            name={props.name}
            style={{display: 'none'}}
        >
            <Input />
        </Form.Item>
    );
}
